<template>
	<div class="lessons">
		<div
			@click="onClickRoute(lesson.is_active, lesson.id)"
			class="lesson"
			:class="`${type} ${lesson.is_active ? 'is_active' : 'lock'}`"
			:key="lesson.id"
			v-for="(lesson, index) in lessons"
		>
			<span v-if="index !== lessons.length - 1" class="lesson-number">
				{{ lesson.order }}
			</span>
			<span class="test-icon" v-else>
				<IconAward />
			</span>
			<p v-if="index !== lessons.length - 1" class="name">{{ lesson.name }}</p>
			<p v-else class="name">{{ lesson.order }}. {{ lesson.name }}</p>
			<span class="chevron" v-if="lesson.is_active">
				<IconChevron
					orientation="right"
					:fill="
						isLast(index) ? '#fff' : type === 'pause' ? '#FFD210' : '#78D090'
					"
				/>
			</span>
			<span class="chevron" v-else>
				<IconLock :fill="isLast(index) ? '#fff' : '#4F4F4F'" />
			</span>
		</div>
	</div>
</template>

<script>
import IconChevron from '@/components/svg/IconChevron'
import IconAward from '@/components/svg/IconAward'
import IconLock from '@/components/svg/IconLock'

export default {
	name: 'GroupLessons',
	methods: {
		onClickRoute(is_active, id) {
			if (!is_active) return
			else {
				this.$router.push({
					name: 'Dashboard Student Lesson',
					params: { id },
				})
			}
		},
		isLast(index) {
			return index === this.length - 1
		},
	},
	components: {
		IconChevron,
		IconAward,
		IconLock,
	},
	props: {
		lessons: {
			default: [],
		},
		length: Number,
		type: String,
	},
}
</script>

<style lang="scss" scoped>
$color-orange: #ffc73b;
$color-gray-light: #f2f2f2;
$color-gray: #828282;
$color-gray-dark: #4f4f4f;
$color-pink: #fa0b76;
$color-yellow: #ffd210;
$color-green: #78d090;

.lessons {
	display: grid;
	margin: 0 12px;
	grid-column-gap: 24px;
	grid-template-columns: repeat(4, 1fr);

	@media (max-width: 1200px) {
		display: block;

		max-width: 360px;

		margin-left: auto;
		margin-right: auto;

		// flex-wrap: wrap;
	}
}

.test-icon {
	width: 48px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.lesson {
	min-height: 60px;
	background-color: #fff;
	border-radius: 0;
	//flex: 1;
	color: $color-gray-dark;
	display: flex;

	padding: 0;

	@media (max-width: 1200px) {
		//flex-basis: 100%;
		//margin-right: 0;
	}

	&-number {
		width: 48px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #fff;
		font-weight: bold;
		font-size: 24px;
		line-height: 140%;
		background-color: $color-green;
	}

	&:last-child {
		margin-right: 0;
		background-color: $color-green;
		color: #fff;

		svg path {
			fill: #fff;
		}
	}

	&.pause {
		.lesson-number {
			background-color: $color-yellow;
		}

		&:last-child {
			background-color: $color-yellow;
		}
	}

	&.is_active {
		cursor: pointer;
	}

	&.lock {
		cursor: not-allowed;

		.lesson-number {
			background-color: #bdbdbd;
		}

		&:last-child {
			background-color: #bdbdbd;
		}
	}
}

.name {
	flex: 1;
	font-weight: bold;
	font-size: 16px;
	line-height: 140%;
	margin-left: 10px;
	display: flex;
	align-items: center;
	@media (max-width: 1200px) {
		display: flex;
		justify-content: center;
	}
}

.chevron {
	display: flex;

	width: 42px;
	height: 100%;
	justify-content: center;
	align-items: center;

	@media (max-width: 1200px) {
		display: block;

		padding-top: 15px;
		padding-left: 15px;
	}
}
</style>
